import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Play, Calendar, Film, ChevronRight } from "lucide-react";
import { API } from "@/config";

export default function DocumentariesPage() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    fetchDocumentaries();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- mount-only fetch
  
  const fetchDocumentaries = async () => {
    try {
      const res = await axios.get(`${API}/videos?video_type=documentary`);
      setVideos(res.data);
    } catch (err) {
      console.error("Error fetching documentaries:", err);
    } finally {
      setLoading(false);
    }
  };
  
  if (loading) {
    return (
      <div className="loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }
  
  return (
    <div className="container" style={{ padding: '2rem 1rem 4rem' }}>
      <nav className="breadcrumb">
        <Link to="/vault">The Vault</Link>
        <ChevronRight size={16} className="breadcrumb-separator" />
        <span>Documentaries</span>
      </nav>
      
      <div className="section-header">
        <h1 className="section-title" style={{ fontSize: '2rem' }}>Documentaries</h1>
        <span className="btn btn-secondary" style={{ cursor: 'default' }}>
          <Film size={16} />
          {videos.length} {videos.length === 1 ? 'Documentary' : 'Documentaries'}
        </span>
      </div>
      
      {videos.length === 0 ? (
        <div className="empty-state">
          <Film className="empty-state-icon" />
          <h3 className="empty-state-title">No Documentaries Yet</h3>
          <p className="empty-state-text">Documentaries will be added soon.</p>
        </div>
      ) : (
        <div className="video-grid">
          {videos.map((video) => (
            <Link 
              key={video.id} 
              to={`/watch/${video.id}`} 
              className="video-card"
            >
              <div className="video-card-thumbnail">
                <img 
                  src={video.thumbnail || 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=400&q=80'} 
                  alt={video.title}
                />
                <div className="video-card-play">
                  <div className="video-card-play-icon">
                    <Play size={24} />
                  </div>
                </div>
                {video.duration && (
                  <span className="video-card-duration">{video.duration}</span>
                )}
              </div>
              <div className="video-card-body">
                <h3 className="video-card-title">{video.title}</h3>
                <div className="video-card-meta">
                  <span className="video-card-meta-item">
                    <Calendar size={14} />
                    {video.date}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
